import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
//import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
//import { loadStripe } from '@stripe/stripe-js';
//import { Elements } from '@stripe/react-stripe-js';


import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import { MdOutlineLocalGroceryStore } from "react-icons/md";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";


import Banner from "../../images/store/store.png";



const ItemCard = () => {
    // add access to the sql datatabase
    const { id } = useParams();
    const [shirt, setShirt] = useState({});
    useEffect(() => {
        const fetchShirt = async () => {
            try {
            const res = await fetch(`/api/get-shirts/${id}`);
            const data = await res.json();
            console.log(data);
            setShirt(data);
            } catch (err) {
            console.error("Failed to fetch shirts:", err);
            }
        };
        
        fetchShirt();
    }, []);
    
    return (
        <div className="store-item-container">
            <div className="item-info-box">
                <div className="store-circle-container"> <div className="store-circle"> <MdOutlineLocalGroceryStore className="store-icon" /></div></div>
                <span className="item-name"> {shirt.title} </span>
                <div class="store-details">
                    <span className="item-price">  {shirt.price}€</span>
                </div>
            </div>
            <div className="store-image-container"> <img alt="t-shirt image" src={`https://herzdoktor.onrender.com/uploads/${shirt.imagepath}`}/></div>
        </div>
    )
}

/*
const PaymentForm = () => {
    // checkout code
    const { id } = useParams();
    const stripe = useStripe();
    const elements = useElements();

    const [formData, setFormData] = useState({ name:'', email:'', street:'', door:'', zip:'' });
    const [paymentStatus, setPaymentStatus] = useState('');

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData({
            ...formData,
            [name]: value
        })
    }

    // payment process
    const handleSubmit = async (e) => {
        e.preventDefault();
        const cardElement = elements.getElement(CardElement);
        try {
            const response = await fetch('/api/create-payment-intent', {
                method: 'POST',
                headers: {'Content-Type':'application/json'},
                body: JSON.stringify({ ...formData, id })
            });

            const { clientSecret } = await response.json();
            const result = await stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: cardElement,
                    billing_details: {
                        name: formData.name,
                        email: formData.email
                    }
                }
            })

            if (result.error) {
                setPaymentStatus(`Payment failed: ${result.error.message}`);
            } else {
                setPaymentStatus('Payment succeeded!');
                setFormData({name:'', email:'', street:'', door:'', zip:''})
                cardElement.clear();
            }

        } catch (error) {
            setPaymentStatus("Error processing payment.");
        }
    }

    return (
        <form class="payment-form" onSubmit={handleSubmit}>
            <h2>Payment Details</h2>

            <div class="form-group">
                <label for="name"> Name</label>
                <input value={formData.name} onChange={handleChange}  type="text" id="name" name="name" placeholder="Dein Name" required />
            </div>

            <div class="form-group">
                <label for="email">Email</label>
                <input value={formData.email} onChange={handleChange}  type="text" id="email" name="email" placeholder="name@gmail.com" required />
            </div>

            <div class="form-group">
                    <label for="street">Strasse</label>
                    <input value={formData.street} onChange={handleChange}  type="text" id="street" name="street" placeholder="Strasse" required />
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label for="door">Tür</label>
                    <input value={formData.door} onChange={handleChange}  type="text" id="door" name="door" placeholder="123" required />
                </div>
                <div class="form-group">
                    <label for="zip">ZIP </label>
                    <input value={formData.zip} onChange={handleChange}  type="text" id="zip" name="zip" placeholder="12345" required />
                </div>
            </div>
            
            <CardElement options={{ style: { base: { fontSize: '16px' } }, postalCode: true }}/>

            <button disabled={!stripe} type="submit" class="submit-btn">Bezahlen</button>
            {paymentStatus && <p>{paymentStatus}</p>}
        </form>
    )
}

// public key
const stripePromise = loadStripe('pk_live_51RrHWgHM7Q9FG8Y9SJnXhO0nJMUqvmRT9d6UZkHDXsjU8FD7VxKTdbNAsX10jNdMTEOBXPje4SxIM7pX0cdi6hYQ00HthaJGKV');
const PaymentComponent = () => {
  return (
    <div>
      <Elements stripe={stripePromise}>
        <PaymentForm />
      </Elements>
    </div>
  );
};
*/


// Paypall
const PaymentComponent = () => {
    // checkout code
    const { id } = useParams();

    const [formData, setFormData] = useState({ name:'', email:'', country:'', street:'', door:'', zip:'',quantity: 1 });
    const [paymentStatus, setPaymentStatus] = useState('');

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData({
            ...formData,
            [name]: name === "quantity" ? Math.max(1, parseInt(value)) : value
        })
    }

    const isFormValid =
        formData.name.trim() &&
        /\S+@\S+\.\S+/.test(formData.email) && 
        formData.street.trim() &&
        formData.door.trim() &&
        /^\d{4,5}$/.test(formData.zip); 

    const createOrder = async () => {
        const res = await fetch("/api/create-paypal-order", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id, quantity: formData.quantity }),
        });
        const data = await res.json();
        return data.id;
    }

    const onApprove = async (data) => {
        const res = await fetch("/api/capture-paypal-order", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ orderID: data.orderID, shirtid: id, quantity: formData.quantity, ...formData }),
        });
        const details = await res.json();
        setFormData({ name:'', email:'', country:'', street:'', door:'', zip:'', quantity: 1 });
        setPaymentStatus('T-Shirt bestellt!');
    }
    

    return (
        <form class="payment-form">
            <h2>Payment Details</h2>

            <div class="form-group">
                <label for="name"> Name</label>
                <input value={formData.name} onChange={handleChange}  type="text" id="name" name="name" placeholder="Dein Name" required />
            </div>

            <div class="form-group">
                <label for="email">Email</label>
                <input value={formData.email} onChange={handleChange}  type="text" id="email" name="email" placeholder="name@gmail.com" required />
            </div>


            <div class="form-group">
                <label for="country">Land</label>
                <input value={formData.country} onChange={handleChange} type="text" id="country" name="country" placeholder="Österreich" required />
            </div>

            <div class="form-group">
                    <label for="street">Strasse</label>
                    <input value={formData.street} onChange={handleChange}  type="text" id="street" name="street" placeholder="Strasse" required />
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label for="door">Tür</label>
                    <input value={formData.door} onChange={handleChange}  type="text" id="door" name="door" placeholder="123" required />
                </div>
                <div class="form-group">
                    <label for="zip">ZIP </label>
                    <input value={formData.zip} onChange={handleChange}  type="text" id="zip" name="zip" placeholder="12345" required />
                </div>
            </div>

            <div class="form-group">
                <label htmlFor="quantity">Anzahl</label>
                <input
                    type="number"
                    id="quantity"
                    name="quantity"
                    value={formData.quantity}
                    onChange={handleChange}
                    min={1}
                    required
                />
            </div>

            <PayPalScriptProvider options={{ "client-id": "AZOwNuwcxQf8rHo51eZdyyAVyfKQnyo-l2w3jfdysoA0OWoiwMqd8GKMM5oQiUFcofl_GrfGIyMsbxY0", currency: "EUR" }}>
                <PayPalButtons
                    createOrder={createOrder}
                    onApprove={onApprove}
                    style={{ layout: "vertical" }}
                    disabled={!isFormValid} 
                />
            </PayPalScriptProvider>
            { paymentStatus || ""}
        </form>
    )
}

  

const Checkout = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />
                

                <div className="page-container">

                    <h1> T-Shirt Checkout </h1>
                    <div className="checkout-container">
                        <ItemCard />
                        <PaymentComponent />
                    </div>
                </div>
            </section>
            <Footer />
        </main>
    )
}

export default Checkout;
